module.exports = __webpack_public_path__ + "img/red-ellipse-curve.53e622c3.svg";